import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import shared from '../../../utils/shared.js';
const QuillDeltaToHtmlConverter = require('quill-delta-to-html');

class StoryMiami extends Component {

  constructor(props) {
    super(props);
    this._subscribeModule = null;
    this._showBackground = true;
    this._uiStrip = "/img/miami/general/rainbowuistrip.png";
    this.getSubscribeModule();
    if (this.props.showBackground !== undefined) {
      this._showBackground = this.props.showBackground;
    }

    if (this.props.contentIndex !== undefined) {
      this._story = this.props.stories[this.props.contentIndex];
    } else {
      this._story = this.props.stories[0];
    }

    this.state = {
      image: null,
      dimensions: null
    }
  }

  async componentDidMount() {
    const imageObj = new Image();
    const imagePath = shared.dp(this.props.screen, this._story.contents.images[0]);
    imageObj.src = imagePath;
    const dimensions = await new Promise((resolve, reject) => {
      imageObj.onload = function() {
        return resolve({ width: this.width, height: this.height });
      }
    });
    this.setState({
      image: imagePath,
      dimensions: dimensions
    })
  }

  getBackgroundImage = () => {
    if (this._showBackground === false) {
        return null;
    }
    if (this.props.background) {
      return this.props.background;
    }
    const defaultImg = { path:'/img/miami/general/', file_name:'default_single_screen.jpg' }
    if (this.props.screensNumber === 2) {
      defaultImg.file_name = 'default_double_screen.jpg';
    }
    const folderModule = this.props.content.folder_modules.find(fm => fm.id === this._story.folder_module_id);
    const folder = this.props.content.story_categories.find(fl => fl.id === folderModule.folder);
    return shared.dp(this.props.screen, _.get(folder, 'contents.images[2]', null), defaultImg);
  }

  getSubscribeModule = () => {
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    const menu = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(rootFolderId) && type === "menu";
    });
    const colorPallette = _.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
    if (colorPallette === "adaptive") {
      this._uiStrip = "/img/miami/general/rainbowuistrip_green.png";
    }
    const subscribeModule = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(menu.id) && type === "be_the_change";
    });
    this._subscribeModule = subscribeModule;
  }

  redirect = () => {
    if (this._subscribeModule !== null && this._subscribeModule !== undefined) {
      this.props.navRoute('/miami/subscribe', this._subscribeModule);
    }
  }

  render() {
    const unit = this.props.screen.r9_16.p10 / this.props.screensNumber;
    const maxAbsoluteBlockWidth = (this.props.screen.screenWidth / this.props.screensNumber * 0.85) - (this.props.screen.screenHeight * 0.0268 * 2);
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    const colorPallette = _.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
    let helpButton = "/img/miami/general/help_button.png";
    if (colorPallette === "adaptive") {
      helpButton = "/img/miami/general/help_button_green.png";
    }

    const imageStyle = {
      height: '33vh',
      width: '85%',
      borderTopLeftRadius: "3.125vh",
      borderTopRightRadius: "3.125vh",
      margin: "auto",
      overflow:"hidden"
      // backgroundSize: "cover",
      // backgroundPosition:"center",
      // backgroundRepeat: "no-repeat"
    };

    const imagePath = shared.presetDp("story_pill", _.get(this._story, 'contents.images[0]', {path: '/img/ui/', file_name: 'image_default.png'}), this.props.screen)

    
    let backgroundImage = this.getBackgroundImage();
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
    let bodyRichText = new QuillDeltaToHtmlConverter(_.get(this._story, 'contents.custom_fields.body.val.ops', _.get(this._story, 'contents.custom_fields.body.default.ops', null)), {}).convert();
    let subtitleRichText = new QuillDeltaToHtmlConverter(_.get(this._story, 'contents.custom_fields.subtitle.val.ops', _.get(this._story, 'contents.custom_fields.subtitle.default.ops', null)), {}).convert();
    
    let maxWidth = 0, maxHeight = 0, verticalAlign = "middle";
    if (this.state.dimensions) {
      const ratio = this.state.dimensions.width / this.state.dimensions.height;
      if (this.state.dimensions.width > this.state.dimensions.height) {
        verticalAlign = "bottom";
        maxWidth = this.state.dimensions.width;
        maxHeight = this.state.dimensions.height;
        if (this.state.dimensions.width > this.props.screen.screenWidth / this.props.screensNumber * .85) {
          maxWidth = this.props.screen.screenWidth / this.props.screensNumber * .85;
          maxHeight = maxWidth / ratio;
        }
        if (maxHeight > this.props.screen.screenHeight * .33) {
          maxHeight = this.props.screen.screenHeight * .33;
          maxWidth = maxHeight * ratio;
        }
      } else {
        maxHeight = this.props.screen.screenHeight * .33;
        maxWidth = maxHeight * ratio;
      }
    }

    const sideText = _.get(this._story, 'contents.custom_fields.side_text.val', null);
    
    return (
      <div style={{ width:this.props.screen.screenWidth / this.props.screensNumber, height:this.props.screen.screenHeight, backgroundImage:"url("+backgroundImage+")", backgroundSize: backgroundSize }}>
        <div style={{ top:"5vh", position:"absolute", width: this.props.screen.screenWidth / this.props.screensNumber, height: "100vh"  }} >
          <div style={{ display: "block", margin: "auto" }}>
            <div style={{ ...imageStyle, backgroundColor: "white", textAlign: "center", display: "table" }}>
              <div style={{ display: "table-cell", verticalAlign: verticalAlign }}>
                <img src={imagePath} style={{ width: maxWidth, height: maxHeight, margin: "auto", verticalAlign:"bottom" }} alt="" />
              </div>
            </div>
          </div>

          <div>
            <img alt="Stripe" style={{ display: "block", margin: "auto", height: this.props.screen.r9_16.height * .004, width: "85%" }} src={this._uiStrip} />
          </div>

          <div style={{ display: 'block', margin: "auto", height: '57vh', width: '85%', backgroundColor: 'white', borderBottomLeftRadius: "3.125vh", borderBottomRightRadius: "3.125vh", }}>
            <div style={{ fontSize: '2.25vh', textAlign: "left", marginLeft: unit * .5, fontFamily: "opensans-bold", color: '#404040' }}>
            </div>
            <div style={{ height:"1.12vh" }}/>
            <div style={{ fontFamily: "sans-serif", textAlign: "left", paddingRight:"2.68vh", paddingLeft:"2.68vh",color:"#404040", maxHeight:"9.765625vh", overflowY:"hidden", minHeight: "2.6041666666666666666vh", fontSize: "2.7773vh", marginTop: "2vh" }}>
              {this._story.name}
            </div>
            <div className="miami-subtitle ql-editor ql-size-12px" style={{ textAlign: "left", paddingRight:"2.68vh", paddingLeft:"2.68vh",color:"#404040", maxHeight:"9.765625vh", overflowY:"hidden", minHeight: "2.6041666666666666666vh", lineHeight:"1.5vh", paddingTop: "0.5vh", paddingBottom: "0.5vh" }} dangerouslySetInnerHTML={{ __html: subtitleRichText }}/>
            <div style={{ height: "43vh", paddingTop:"0.4921875vh", paddingLeft:"2.68vh", paddingRight:"2.68vh", paddingBottom:"1.68vh", display:"table", position:"absolute", width:maxAbsoluteBlockWidth }}>
              <div style={{ display:"table-row" }}>
                <div className="miami-bullet" style={{ display: "table-cell", width:"65%" }}>
                  <div style={{ float:"left", color:"#404040", maxHeight:"44vh", lineHeight: 0.01041666666666666667 * this.props.screen.screenHeight + "px" , overflowY: 'hidden', fontSize: 0.01041666666666666667 * this.props.screen.screenHeight + "px" }} className="ql-editor" dangerouslySetInnerHTML={{ __html: bodyRichText }}/>
                </div>
                <div style={{ display: "table-cell", width:"32%", paddingLeft:"0.5vh", paddingRight:"0.5vh", position:"absolute" }}>
                  <div style={{ float:"left" }}>
                    {
                      sideText !== null && sideText !== "" ?
                      <div>
                        <img alt="Stripe" style={{ display: "block", margin: "auto", height: this.props.screen.screenHeight * .001, width: "85%" }} src={this._uiStrip} />
                        <div style={{ fontFamily: "legacysans-bookitalic", fontSize: '1.2375vh', color: 'black', paddingTop:"1.5625vh", paddingBottom:"1.5625vh", width:"85%", margin:"0 auto", textAlign:"center" }}>
                          {sideText}
                        </div>
                        <img alt="Stripe" style={{ display: "block", margin: "auto", height: this.props.screen.screenHeight * .001, width: "85%" }} src={this._uiStrip} />
                      </div>
                      : null
                    }
                    <img alt="Be The Change" onClick={this.redirect} style={{ backgroundColor: 'white', display: "block", margin: "auto", width: "80%", textAlign:"center", paddingTop: "4.17vh" }} src={helpButton} />
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    content: state.content,
    screen: state.screen
  };
};

export default connect(mapStateToProps, null)(StoryMiami);



// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/StoryMiami.js